import React, { useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import useChargebackDetails from './hooks/useChargebackDetails';
import ChargebackDetailsView from './view';
import SubmitDisputeModal from '@components/_modals/Billing/SubmitDisputeModal';

export default function ChargebackDetails({ chargebackId }) {
    const navigate = useNavigate();
    const disputeModalRef = useRef({});
    const { chargeback, loading, error, refetch } = useChargebackDetails(chargebackId);

    return (
        <>
            <ChargebackDetailsView
                chargeback={chargeback}
                loading={loading}
                error={error}
                navigate={navigate}
                chargebackId={chargebackId}
                onDispute={() => disputeModalRef.current.open({ chargebackId }, refetch)}
            />
            <SubmitDisputeModal modalRef={disputeModalRef} />
        </>
    );
}
